/**
 * This component is used to validate the auth values.
 */

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import { publishEvent } from "../../../components/generic/EventPublisher";
import apiService from "../../../service/apiservice/apiService";
import CustomModal from "../../../components/generic/custommodal/CustomModal";
import { strings } from "../../utils/strings";
import SecondaryButton from "../../../components/generic/buttons/SecondaryButton";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import { clearLocalStorage } from "./utils";
import { useSetRecoilState } from "recoil";
import { userDetails } from "../../../components/recoil/userDataRecoil";

const Logout = () => {
  const navigate = useNavigate();
  const userData = useReadMemory(MemoryType.USER);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(true);
  const setUserDetails = useSetRecoilState(userDetails)

  const signOut = async () => {
    setLoading(true);
    const deleteEndpoint = "event/device/v1/" + userData?.email || "";
    await apiService.delete(deleteEndpoint);
    publishEvent("niramaya.user.logout", userData);
    clearLocalStorage();
    setUserDetails({})
    navigate("/login");
    setLoading(false);
  };

  const handlePrimaryButton = () => {
    navigate(RoleToLinkMapper(userData.jobTitle) + "homepage");
  };

  const footerButtons = (
    <>
      <SecondaryButton
        buttonText={strings.SIGNOUT}
        handleOnClick={signOut}
        loading={loading}
      />
      <PrimaryButton
        buttonText={strings.KEEP_SIGN_IN}
        handleOnClick={handlePrimaryButton}
      />
    </>
  );

  return (
    <>
      <CustomModal
        closable={false}
        isModalOpen={openModal}
        footer={footerButtons}
        closeModal={setOpenModal}
      >
        <div>
          <h5 className="logout-prompt-title">Confirm Sign Out</h5>
          <div>
            You are about to sign out of your account. Stay signed in to keep
            your session active, or sign out to exit securely. Please select an
            option.
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default Logout;
